// API Configuration
import { backendUrl } from '../config/environment';

export const BACKEND_URL = backendUrl;
export const API = `${backendUrl}/api`;

/** Params for discover/runs list (homepage, same as mobile RunScreen) */
export const DISCOVER_MEETINGS_PARAMS = {
  limit: 100,
  status: "upcoming",
  sort_by: "distance",
};

/** Default limit for clubs on homepage */
export const HOMEPAGE_CLUBS_LIMIT = 50;

/** Master user email: this user can access the ops console via normal login. Must match backend MASTER_EMAIL. */
export const MASTER_EMAIL = 'runcards@gmail.com';
